export default __webpack_public_path__ + "static/media/sneaker_img.a6579098.png";